import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-progress-bar",
    styleUrl: "progress-bar.scss",
    shadow: true
})
export class ProgressBar {
    /** Number of total steps */
    @Prop() readonly steps: number;
    /** Index of current step */
    @Prop() readonly current: number;

    private get progressPercentage(): number {
        return (this.current / this.steps) * 100;
    }

    render() {
        return (
            <Host>
                <div class="top-container">
                    <div>
                        <slot name="button" />
                    </div>
                    <div>
                        <span class="step step-bold">{this.current}</span>
                        <span class="step"> / {this.steps}</span>
                    </div>
                </div>
                <div
                    class="bar"
                    role="progressbar"
                    aria-valuenow={this.current}
                    aria-valuemin={0}
                    aria-valuemax={this.steps}
                    aria-valuetext={`${this.progressPercentage}%`}
                >
                    <div class="fill" style={{ width: `${this.progressPercentage}%` }}></div>
                </div>
            </Host>
        );
    }
}
